import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import Pageable, { PageEventListener } from '@philips-emr/tws-core/lib/component/types/pageable';

class DeckAPI extends ComponentAPI implements Clickable, Pageable {
  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onNextPage = new PageEventListener();

  /** @event */
  @AwesomeEvent
  onPrevPage = new PageEventListener();

  getData(): object[] {
    return this.state.data;
  }

  setData(data: object[]): void {
    this.setState({ data });
  }

  isDone(): boolean {
    return this.state.done;
  }

  setDone(done: boolean): void {
    this.setState({ done });
  }

  getLimit(): number {
    return this.state.limit;
  }

  setLimit(limit: number): void {
    this.setState({ limit });
  }

  getLoadMoreExpression(): string {
    return this.state.loadMoreExpression;
  }

  setLoadMoreExpression(loadMoreExpression: string): void {
    this.setState({ loadMoreExpression });
  }

  setLoading(loading: boolean): void {
    this.setState({ loading });
  }

  isLoading(): boolean {
    return this.state.loading;
  }

  setReset(reset: boolean): void {
    this.setState({ reset });
  }

  isReset(): boolean {
    return this.state.reset;
  }
}

export default DeckAPI;
